import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { MenuItem, Divider } from 'material-ui';
import FlatDropDownMenu from '../../tc-ui/flatDropDownMenu';
import ArrowDropDownIcon from 'material-ui/svg-icons/navigation/arrow-drop-down';
import { JiraFlatButton } from '../../tc-ui/small-buttons';

class AssigneeFilter extends Component {
  constructor() {
    super();
  }
  onClick = userId => () => {
    const { filterByAssignee } = this.props;
    filterByAssignee(userId);
  };
  render() {
    const {
      filter,
      button,
      usersArray,
      isContainer,
    } = this.props;
    const filterLabel = (() => {
      if (filter === 'dl@tourconnect.com') return filter;
      if (filter === 'unassigned') return 'Unassigned';
      if (filter) {
        const match = usersArray.find(user => user.userId === filter);
        if (match) return match.name || match.email;
      }
      return 'Assignee';
    })();
    return (
      <FlatDropDownMenu
        button={
          button || <JiraFlatButton
            labelStyle={{ fontSize: '12px', fontWeight: filter ? 'bold' : 'normal', color: filter ? 'black' : 'rgba(0, 0, 0, 0.54)' }}
            icon={<ArrowDropDownIcon style={{ fill: 'rgba(0, 0, 0, 0.54)', margin: 0 }}/>}
            labelPosition="before"
            label={filterLabel}
          />
        }
      >

        <MenuItem
          primaryText="All"
          onClick={this.onClick(null)}
        />
        <MenuItem
          primaryText="Unassigned"
          onClick={this.onClick('unassigned')}
        />
        <Divider/>
        {
          usersArray.map(user => (
            <MenuItem
              key={user.userId}
              primaryText={user.name || user.email}
              disabled={user.userId === filter}
              onClick={this.onClick(user.userId)}
            />
          ))
        }
        {
          // isContainer && (<Divider/>)
        }
        {
          // isContainer && (
          //   <MenuItem
          //     primaryText="dl@tourconnect.com"
          //     onClick={this.onClick('dl@tourconnect.com')}
          //   />
          // )
        }
      </FlatDropDownMenu>
    );
  }
}

AssigneeFilter.propTypes = {
  filterByAssignee: PropTypes.func,
  filter: PropTypes.string,
  button: PropTypes.node,
  usersArray: PropTypes.array,
  isContainer: PropTypes.bool,
};

export default connect(state => ({
  usersArray: state.settings.get('allActiveUsers').toJS
  ? state.settings.get('allActiveUsers').toJS()
  : state.settings.get('allActiveUsers'),
}))(AssigneeFilter);



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/assignee-filter.jsx